import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(public translate: TranslateService){
    this.langOption();
  }
  
  langOption() {
    this.translate.addLangs(['en', 'de']);
    if (localStorage.getItem('locale')) {
      const browserLang : any = localStorage.getItem('locale');
      this.translate.use(browserLang.match(/en|de/) ? browserLang : 'de');
    } else {
      this.setDefaultLang();
    }
  }

  setDefaultLang(){
    localStorage.setItem('locale', 'de');
    this.translate.setDefaultLang('de')
  }

  changeLang(language: string) {
    localStorage.setItem('locale', language);
    this.translate.use(language);
  }

}
